import { cliente } from '@/lib/cliente';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useProveedoresPactados() {
  return useQuery({
    queryKey: ['proveedores-pactados'],
    queryFn: () => cliente.proveedoresPactados.listar(),
  });
}

/** Marcar/desmarcar cambia qué facturas ofrece una propuesta: refresca también el detalle de vencimientos. */
export function useMarcarProveedorPactado() {
  const queryClient = useQueryClient();
  const invalidar = () => {
    queryClient.invalidateQueries({ queryKey: ['proveedores-pactados'] });
    queryClient.invalidateQueries({ queryKey: ['vencimientos-detalle'] });
  };
  const marcar = useMutation({
    mutationFn: ({ vendorCode, motivo }: { vendorCode: string; motivo: string | null }) =>
      cliente.proveedoresPactados.marcar(vendorCode, motivo),
    onSuccess: invalidar,
  });
  const desmarcar = useMutation({
    mutationFn: (vendorCode: string) => cliente.proveedoresPactados.desmarcar(vendorCode),
    onSuccess: invalidar,
  });
  return { marcar, desmarcar };
}
